/*
 * MyGenie — Animation Controller
 */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── 1. Hero banner ── */
  function initHero() {
    var banner = document.querySelector('.banner__media');
    if (!banner) return;
    banner.classList.add('mg-hero-animate');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        banner.classList.add('mg-anim-in');
      });
    });
  }

  /* ── 2. Trust bar ── */
  function initTrustBar() {
    var trust = document.querySelector('.mg-trust--desktop');
    if (!trust) return;
    trust.classList.add('mg-trust-animate');
    var items = trust.querySelectorAll('.mg-trust__item');
    items.forEach(function (item, i) {
      setTimeout(function () { item.classList.add('mg-anim-in'); }, 200 + i * 70);
    });
  }

  /* ── 3. Scroll-triggered reveals ── */
  function initScrollReveals() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.mg-reveal, .mg-reveal-left, .mg-stagger').forEach(function (el) {
        el.classList.add('mg-anim-in');
      });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mg-anim-in');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.mg-reveal, .mg-reveal-left, .mg-stagger').forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ── 4. Collection grid stagger ──
     Only targets .product-grid elements that are NOT inside product-recommendations
     or related-products sections, so PDP recommendation cards are never affected. */
  function initGridReveal() {
    if (!('IntersectionObserver' in window)) return;

    var grids = document.querySelectorAll('.product-grid');
    grids.forEach(function (grid) {
      /* Skip grids inside product-recommendations or related-products */
      if (grid.closest('product-recommendations') || grid.closest('.related-products')) return;

      /* Tag items hidden NOW via a class (not global CSS) */
      var items = grid.querySelectorAll('.grid__item');
      items.forEach(function (item) { item.classList.add('mg-grid-item-hidden'); });

      var gridObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var revealItems = entry.target.querySelectorAll('.mg-grid-item-hidden');
            revealItems.forEach(function (item, i) {
              setTimeout(function () {
                item.classList.remove('mg-grid-item-hidden');
                item.style.opacity = '1';
                item.style.transform = 'translateY(0)';
              }, i * 60);
            });
            entry.target.classList.add('mg-grid-revealed');
            gridObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.05 });

      gridObserver.observe(grid);
    });

    /* Most Loved product cards */
    var lovedGrid = document.querySelector('.mg-loved__grid');
    if (lovedGrid) {
      var cards = lovedGrid.querySelectorAll('.mg-lpc');
      cards.forEach(function (card) {
        card.style.opacity = '0';
        card.style.transform = 'translateY(20px)';
        card.style.transition = 'opacity 0.55s cubic-bezier(0.22,1,0.36,1), transform 0.55s cubic-bezier(0.22,1,0.36,1)';
      });
      var lovedObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            cards.forEach(function (card, i) {
              setTimeout(function () {
                card.style.opacity = '1';
                card.style.transform = 'translateY(0)';
              }, i * 100);
            });
            lovedObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });
      lovedObserver.observe(lovedGrid);
    }
  }

  /* ── 5. Section headings ── */
  function initSectionHeadings() {
    ['.mg-loved__head', '.mg-test__head'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el) el.classList.add('mg-reveal');
    });
  }

  /* ── Run ── */
  if (reduced) return;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initHero(); initTrustBar(); initSectionHeadings(); initScrollReveals(); initGridReveal();
    });
  } else {
    initHero(); initTrustBar(); initSectionHeadings(); initScrollReveals(); initGridReveal();
  }
})();
